<template>
	<div class="d21-profile__content d21-profile__login">
		<ValidationObserver ref="observer" v-slot="{ passes }">
			<form @submit.prevent="passes(() => {})" autocomplete="disabled" onkeydown="return event.key != 'Enter';" v-if="mode === 'profile_approve'">
				<div class="mdl-grid">
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group success">
						<i class="material-icons">check_circle</i>
						{{ T("ticketing_account_activated") }}
					</div>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m buttons">
						<button class="btn btn-primary" @click="toLogin">
							<span>{{ T("ticketing_to_login") }}</span>
						</button>
					</div>
				</div>
			</form>
			<form @submit.prevent="passes(() => {})" autocomplete="disabled" onkeydown="return event.key != 'Enter';" v-else-if="mode === 'password_forgotten'">
				<h3>{{ T("ticketing_reset_password") }}</h3>
				<div class="mdl-grid" v-if="isResetMailSent">
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group success">
						<i class="material-icons">check_circle</i>
						{{ T("ticketing_email_reset_confirmation", username) }}
					</div>
				</div>
				<div class="mdl-grid" v-else>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
						<label>{{ T("email") }}</label>
						<ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
							<input v-model.trim="username" type="text" class="mdl-textfield__input" />
							<span class="error">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m buttons" v-if="!hideButtons">
						<br />
						<Button class="btn btn-primary" @click="sendResetPasswordRequest" :text="T('ticketing_reset')" :is-loading="isLoginPending" is-primary />
						<button class="btn btn-black-outline" v-on:click="mode = null">
							<span>{{ T("cancel") }}</span>
						</button>
						<p class="error" v-if="hasError">
							{{ T("ticketing_user_not_found") }}
						</p>
					</div>
				</div>
			</form>
			<form @submit.prevent="passes(() => {})" autocomplete="disabled" onkeydown="return event.key != 'Enter';" v-else-if="mode === 'password_reset'">
				<h3>{{ T("ticketing_reset_password") }}</h3>
				<div class="mdl-grid" v-if="isPasswordChanged">
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group success">
						<i class="material-icons">check_circle</i>
						{{ T("ticketing_password_reset_success") }}
					</div>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m buttons">
						<button class="btn btn-primary" @click="toLogin">
							<span>{{ T("ticketing_to_login") }}</span>
						</button>
					</div>
				</div>
				<div class="mdl-grid" v-else>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
						<label>{{ T("new_password") }}</label>
						<input type="password" v-model.trim="password" autocomplete="off" class="mdl-textfield__input" />
					</div>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
						<label>{{ T("password_repeat") }}</label>
						<input v-model.trim="password_repeat" type="password" autocomplete="off" class="mdl-textfield__input" />
					</div>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
						<passwordStrength :password="password" :password_repeat="password_repeat" @isValid="isValid => isPasswordValid = isValid" />
					</div>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m buttons">
						<button class="btn btn-primary" @click="saveNewPassword" :disabled="!isPasswordValid">
							<span>{{ T("save") }}</span>
						</button>
						<p class="error" v-if="hasError">
							{{ T("ticketing_password_reset_error") }}
						</p>
					</div>
				</div>
			</form>
			<form @submit.prevent="passes(() => {})" autocomplete="disabled" onkeydown="return event.key != 'Enter';" v-else>
				<h3>{{ T("ticketing_login") }}</h3>
				<div class="mdl-grid">
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
						<label>{{ T("email") }}</label>
						<ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
							<input v-model.trim="username" type="text" class="mdl-textfield__input" />
							<span class="error">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
						<label>{{ T("password") }}</label>
						<ValidationProvider name="password" rules="required" v-slot="{ errors }">
							<input v-model.trim="password" type="password" class="mdl-textfield__input" />
							<span class="error">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m links">
						<a @click="onShowProfileRegister()">{{ T("ticketing_register") }}</a>
						<a @click="onShowForgotPassword()">{{ T("ticketing_forgot_password") }}</a>
					</div>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m error" v-if="!isLoginValid">
						<span>{{ T("ticketing_email_or_password_incorrect") }}</span>
					</div>
					<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m buttons" v-if="!hideButtons">
						<Button @click="login" :is-loading="isLoginPending" :text="T('ticketing_login')" is-primary />
						<button class="btn btn-black-outline" @click="toApp">
							<span>{{ T("cancel") }}</span>
						</button>
					</div>
				</div>
			</form>
		</ValidationObserver>
	</div>
</template>

<script>
	import baseMixin from "../mixins/base";
	import passwordStrength from './ui/password-strength.vue'
	import {
		EventBus
	} from "../scripts/_eventBus.js";
	import 'vueperslides/dist/vueperslides.css'
	import {
		email,
	} from "vee-validate/dist/rules";
	import {
		ValidationObserver,
		ValidationProvider,
		extend
	} from "vee-validate";
	import Button from "./ui/button.vue";

	export default {
		mixins: [baseMixin],
		props: {
			hideButtons: {
				type: Boolean,
				default: false
			}
		},
		components: {
			ValidationObserver,
			ValidationProvider,
			passwordStrength,
			Button,
		},
		name: "d21-profile-login",
		data() {
			return {
				isNextButtonActive: false,
				isValid: true,
				hasError: false,
				isPasswordValid: false,
				isPasswordChanged: false,
				buttonShownText: "anmelden",
				buttonHiddenText: "anmelden",
				username: null,
				password: null,
				password_repeat: null,
				isLoginValid: true,
				isLoginPending: false,
				mode: null,
				isResetMailSent: false
			};
		},
		created() {
			extend("email", email);
		},
		mounted() {
			//
			const searchParams = new URLSearchParams(window.location.search);
			if (searchParams.has('profile_approve')) {
				this.approve();
				this.mode = "profile_approve";
			} else if (searchParams.has('password_reset')) {
				this.mode = "password_reset";
			}
		},
		methods: {
			login() {
				const data = {
					Login: this.username,
					Password: this.password
				};
				this.$refs.observer.validate().then((isValid) => {
					if (isValid) {
						this.isLoginPending = true
						this.loadProfile(data, null, null, () => {
							this.isLoginPending = false;
						});
					}
				});
			},
			toApp() {
				this.mode = null;
				this.$router.push(`/${this.$route.params.channel}`);
			},
			toLogin() {
				this.mode = null;
				this.$router.push(`/${this.$route.params.channel}/profile/login`);
			},
			approve() {
				const searchParams = new URLSearchParams(window.location.search);
				const tokenParameter = encodeURIComponent(searchParams.get('profile_approve'));
				this.apiRequest(`/profile/${this.$route.params.channel}/approve?token=${tokenParameter}`, null, "GET", result => {
					if (result.Meta.IsValid) {
						this.hasError = false;
						this.isResetMailSent = true;
					} else {
						this.hasError = true;
						this.isResetMailSent = false;
					}
				}, error => {});
			},
			sendResetPasswordRequest() {
				this.$refs.observer.validate().then((isValid) => {
					if (isValid) {
						this.isLoginPending = true;
						this.apiRequest(`/profile/${this.$route.params.channel}/passwordreset?email=${this.username}`, null, "GET", result => {
							if (result.Meta.IsValid) {
								this.hasError = false;
								this.isResetMailSent = true;
								this.isLoginPending = false;
							} else {
								this.hasError = true;
								this.isResetMailSent = false;
								this.isLoginPending = false;
							}
						}, error => {});
					}
				});
			},
			saveNewPassword() {
				if (this.isPasswordValid) {
					const searchParams = new URLSearchParams(window.location.search);
					const tokenParameter = encodeURIComponent(searchParams.get('password_reset'));
					const passwordParameter = encodeURIComponent(this.password);
					this.apiRequest(`/profile/${this.$route.params.channel}/approvepasswordreset?token=${tokenParameter}&newPassword=${passwordParameter}`, null, "GET", result => {
						if (result.Meta.IsValid) {
							this.hasError = false;
							this.isPasswordChanged = true;
							this.password = null;
							this.password_repeat = null;
						} else {
							this.hasError = true;
							this.isPasswordChanged = false;
						}
					}, error => {});
				}
			},
			onShowProfileRegister() {
				this.$emit("profileRegister", null);
			},
			onShowForgotPassword() {
				this.mode = "password_forgotten";
				this.$emit("onShowForgotPassword", null);
			}
		},
		watch: {
			isLoginPending(newStatus, oldStatus) {
				if (newStatus !== oldStatus) EventBus.$emit("loginPendingStatus", newStatus);
			}
		}
	}
</script>